
   // export let host = "http://localhost:44369/";
//  export let host = "https://localhost:44342/";
 //export let host = "https://homekito.barayand.net/";
// export let host = "https://valhallaplanet.art/";
      export let host = "https://saviz.com/";
  // export let host = "https://homekito.com/";
export let baseUrl = host+"api/cpanel/";
//Contact Address  Url Set
export let addAddress = baseUrl+"ContactAddress/AddAddress";
export let updateAddress = baseUrl+"ContactAddress/UpdateAddress";
export let ActiveAddress = baseUrl+"ContactAddress/ActiveAddress";
export let DisableAddress = baseUrl+"ContactAddress/DisableAddress";
export let DeleteAddress = baseUrl+"ContactAddress/DeleteAddress";
export let LoadAddress = baseUrl+"ContactAddress/LoadAddress";
/////////////////////////
/////Report Urls
export let LoadOrders = baseUrl+"report/Overview/LastOrders";
export let SaleByCategory = baseUrl+"report/Overview/SaleByCategory";
export let TodayIncome = baseUrl+"report/Overview/TodayIncome";
export let TodaySale = baseUrl+"report/Overview/TodaySale";
export let LastSixMonth = baseUrl+"report/Overview/LastSixMonthIncome";
export let TodayCustomers = baseUrl+"report/Overview/TodayCustomers";
//////////////
/////Tickets Urls
export let Ticket = {
   Add : baseUrl+"Ticket/Add",
   Get : baseUrl+"Ticket/Get",
   GetByUser : baseUrl+"Ticket/byuser",
   GetResponses : baseUrl+"Ticket/responses",
   GetEntity : baseUrl+"Ticket/byentity",

}

//////////////
/////Promotion Box Urls
export let AddPromotionBox = baseUrl+"Promotion/AddBox";
export let AddProductToBox = baseUrl+"Promotion/AddProductToBox";
export let LoadPromotionBox = baseUrl+"Promotion/LoadBox";
export let LoadPromotionBoxProds = baseUrl+"Promotion/GetProductRelation";
//////////////
/////Promotion Box Urls
export let AddFestival = baseUrl+"Festival/AddFestival";
export let DeleteFestival = baseUrl+"Festival/DeleteFestival";
export let ActiveFestival = baseUrl+"Festival/ActiveFestival";
export let DisableFestival = baseUrl+"Festival/DisableFestival";
export let LoadAllFestival = baseUrl+"Festival/GetAllFestival";
//////////////
/////Basesetting Urls
export let AddOption = baseUrl+"options/AddOption";
export let LoadOptions = baseUrl+"options/LoadOptions";
//////////////
/////USER Urls
export let SysUserAdd = baseUrl+"user/AddUser";
export let SysUserUpdate = baseUrl+"user/UpdateUser";
export let SysUserSuspend = baseUrl+"user/SuspendUser";
export let SysUserActive = baseUrl+"user/ActiveUser";
export let SysUserLoad = baseUrl+"user/LoadUsers";
export let UserDetaile = baseUrl+"user/detail";
export let SysUserLogin = baseUrl+"user/Login";
export let CustomerChargeWallet = baseUrl+"user/ChargeWallet";
export let CustomerDeacreaseWallet = baseUrl+"user/ReduceWallet";
export let CustomerWalletHistory = baseUrl+"user/LoadWalletHistory";

export let CustomerCat = {
   Add : baseUrl+"user/category/Add",
   Edit : baseUrl+"user/category/Edit",
   Active : baseUrl+"user/category/Active",
   Disable : baseUrl+"user/category/Disable",
   Delete : baseUrl+"user/category/Delete",
   Get : baseUrl+"user/category/Get",
   Combo : baseUrl+"user/category/Combo"
}
////////////////
/////Constant Urls
export let LoadPublicForms = baseUrl+"publicform/GetPublicForms";
export let LoadSellerRequest = baseUrl+"publicform/LoadSellerRequest";
////////////////
export let LoadInvoices = baseUrl+"request/LoadInvoices";
export let LoadOffReqs = baseUrl+"request/LoadOffReqs";
export let LoadAmazingRequests = baseUrl+"basesetting/AmzingRequestes/LoadAmazingRequests";
export let LoadProdFeedback = baseUrl+"basesetting/AmzingRequestes/LoadProductFeedback";
export let LoadBetterPrice = baseUrl+"basesetting/AmzingRequestes/LoadBetterPrice";
export let ChangeStateOffReq = baseUrl+"request/offReqChangeState";
export let ChangeInvoiceState = baseUrl+"request/ChangeInvoiceState";
export let ChangePreOrderPrice = baseUrl+"request/ChangePreOrderPrice";

export let LoadComments = baseUrl+"request/LoadComments";
export let AcceptComment = baseUrl+"request/AcceptComment";
export let DeleteComment = baseUrl+"request/DeleteComment";


export let GetGoldDelivery = baseUrl+"request/golddelivery";
export let GoldDeliveryChangeState = baseUrl+"request/changestate";
export let GetCashRequest = baseUrl+"request/cashrequest";
export let CashChangeState = baseUrl+"request/cashchangestate";
/////Request urls
///////////////
//Product Category Url Set
export let IncreasePrice = baseUrl+"product/IncreasePrice";
export let DecreasePrice = baseUrl+"product/DecreasePrice";
export let registerPc = baseUrl+"product/category/AddCategory";
export let updatePc = baseUrl+"product/category/UpdateCategory";
export let ActivePC = baseUrl+"product/category/ActiveCategory";
export let DisablePC = baseUrl+"product/category/DisableCategory";
export let DeletePC = baseUrl+"product/category/DeleteCategory";
export let LoadProdCats = baseUrl+"product/category/LoadCategory";
export let LoadProdCatsMaxLvlCount = baseUrl+"basesetting/base/GetMaxLevel";
/*Usage In Other Views**/
export let getCategoryAttributes = baseUrl+"product/category/GetCategoryAttributes";//usage in product creation view
export let getCategoryChilds = baseUrl+"product/category/GetCategoryChildsById";//usage in product creation view
export let getCategoiesOfLevelOne = baseUrl+"product/category/GetCategoryLevelOne";//usage in product creation view
export let getOnlyCat1 = baseUrl+"product/category/GetCategoryLvl1";//usage in product creation view
export let getCategoiesOfLevelOneCombo = baseUrl+"product/category/GetCategoryLevelOneCombo";//usage in product creation view
export let getCategoiesOfFinalLevelCombo = baseUrl+"product/category/GetCategoryFinalLevelCombo";//usage in product creation view

//////////////////////////
//Product Label Url Set
export let registerLabel = baseUrl+"sitesetting/productlabel/AddLabel";
export let updateLabel = baseUrl+"sitesetting/productlabel/UpdateLabel";
export let ActiveLabel = baseUrl+"sitesetting/productlabel/ActiveLabel";
export let DisableLabel = baseUrl+"sitesetting/productlabel/DisableLabel";
export let DeleteLabel = baseUrl+"sitesetting/productlabel/DeleteLabel";
export let LoadLabel = baseUrl+"sitesetting/productlabel/LoadLabeles";
export let LoadLabelCpmboItems = baseUrl+"sitesetting/productlabel/LoadLabelComboItems";
/////////////////////////
//Product Brands Url Set
export let registerBrand = baseUrl+"product/brand/AddBrand";
export let updateBrand = baseUrl+"product/brand/UpdateBrand";
export let ActiveBrand = baseUrl+"product/brand/ActiveBrand";
export let DisableBrand = baseUrl+"product/brand/DisableBrand";
export let DeleteBrand = baseUrl+"product/brand/DeleteBrand";
export let LoadBrand = baseUrl+"product/brand/LoadBrand";
export let LoadBrandComboItems = baseUrl+"product/brand/LoadBrandComboItems";
//////////////////////////
//Product Color Url Set
export let registerColor = baseUrl+"product/color/AddColor";
export let updateColor = baseUrl+"product/color/UpdateColor";
export let ActiveColor = baseUrl+"product/color/ActiveColor";
export let DisableColor = baseUrl+"product/color/DisableColor";
export let DeleteColor = baseUrl+"product/color/DeleteColor";
export let LoadColors = baseUrl+"product/color/LoadColors";
export let LoadColorsCombo = baseUrl+"product/color/LoadColorsCombo";
//////////////////////////
//Product Attributes Url Set
export let registerAttribute = baseUrl+"basesetting/attribute/AddAttribute";
export let updateAttribute = baseUrl+"basesetting/attribute/UpdateAttribute";
export let ActiveAttribute = baseUrl+"basesetting/attribute/ActiveAttribute";
export let DisableAttribute = baseUrl+"basesetting/attribute/DisableAttribute";
export let DeleteAttribute = baseUrl+"basesetting/attribute/DeleteAttribute";
export let LoadAttributes = baseUrl+"basesetting/attribute/LoadAttributes";
//////////////////////////
export let registerVAttribute = baseUrl+"basesetting/attribute/AddValueableAttribute";
export let updateVAttribute = baseUrl+"basesetting/attribute/UpdateValueableAttribute";
export let ActiveVAttribute = baseUrl+"basesetting/attribute/ActiveValueAttribute";
export let DisableVAttribute = baseUrl+"basesetting/attribute/DisableValueableAttribute";
export let DeleteVAttribute = baseUrl+"basesetting/attribute/DeleteValueableAttribute";
export let LoadVAttributes = baseUrl+"basesetting/attribute/LoadValueableAttributes";
export let LoadVAttributesByCat = baseUrl+"basesetting/attribute/LoadValueableAttributesByCat";

export let registerVAAttribute = baseUrl+"basesetting/attribute/AddValueableAttrAnswer";
export let updateVAAttribute = baseUrl+"basesetting/attribute/UpdateValueableAttrAnswer";
export let ActiveVAAttribute = baseUrl+"basesetting/attribute/ActiveValueAttrAnswer";
export let DisableVAAttribute = baseUrl+"basesetting/attribute/DisableValueableAttrAnswer";
export let DeleteVAAttribute = baseUrl+"basesetting/attribute/DeleteValueableAttrAnswer";
export let LoadVAAttributes = baseUrl+"basesetting/attribute/LoadValueableAttrAnswerByAttr";
export let LoadVAAttributesByCat = baseUrl+"basesetting/attribute/LoadValueableAttrAnswerByCat";
//Product Coppon Url Set
export let registerCoppon = baseUrl+"coppon/AddCoppon";
export let updateCoppon = baseUrl+"coppon/UpdateCoppon";
export let ActiveCoppon = baseUrl+"coppon/ActiveCoppon";
export let DisableCoppon = baseUrl+"coppon/DisableCoppon";
export let DeleteCoppon = baseUrl+"coppon/DeleteCoppon";
export let LoadCoppon = baseUrl+"coppon/LoadCoppon";
//////////////////////////
//Category Attribute Url Set
export let LoadAttrComboItems = baseUrl+"basesetting/attribute/LoadAttrsComboItems";
export let SetAttrToCategory = baseUrl+"basesetting/catattribute/AddCategoryAttribute";
export let LoadAttrsByCategory = baseUrl+"basesetting/catattribute/LoadAttrsByCategory";
export let updateCatAttribute = baseUrl+"basesetting/catattribute/UpdateCatAttribute";
export let DeleteCatAttribute = baseUrl+"basesetting/catattribute/DeleteCatAttribute";
export let ActiveCatAttribute = baseUrl+"basesetting/catattribute/ActiveCatAttribute";
export let DisableCatAttribute = baseUrl+"basesetting/catattribute/DisableCatAttribute";

export let LoadAnswerByAttCatId = baseUrl+"basesetting/attributeanswer/LoadAnswerByRelation";

//////////////////////////


//Attribute Answer Url Set
export let DisableAttrAnswer = baseUrl+"basesetting/attributeanswer/DisableAttrAnswer";
export let ActiveAttrAnswer = baseUrl+"basesetting/attributeanswer/ActiveAttrAnswer";
export let DeleteAttrAnswer = baseUrl+"basesetting/attributeanswer/DeleteAttrAnswer";
export let AddAttrAnswer = baseUrl+"basesetting/attributeanswer/AddAnswer";
export let UpdateAttrAnswer = baseUrl+"basesetting/attributeanswer/UpdateAnswer";
//////////////////////////





//Product Warranties Url Set
export let registerWarranty = baseUrl+"basesetting/warranty/AddWarranty";
export let updateWarranty = baseUrl+"basesetting/warranty/UpdateWarranty";
export let ActiveWarranty = baseUrl+"basesetting/warranty/ActiveWarranty";
export let DisableWarranty = baseUrl+"basesetting/warranty/DisableWarranty";
export let DeleteWarranty = baseUrl+"basesetting/warranty/DeleteWarranty";
export let LoadWarranty = baseUrl+"basesetting/warranty/LoadWarranty";
export let LoadWarrantyCombo = baseUrl+"basesetting/warranty/LoadWarrantyCombo";
//////////////////////////

//Product Price Formula Url Set
export let registerFormula = baseUrl+"basesetting/formula/AddFormula";
export let updateFormula = baseUrl+"basesetting/formula/UpdateMCountry";
export let ActiveFormula = baseUrl+"basesetting/formula/ActiveFormula";
export let DisableFormula = baseUrl+"basesetting/formula/DisableFormula";
export let DeleteFormula = baseUrl+"basesetting/formula/DeleteFormula";
export let LoadFormula = baseUrl+"basesetting/formula/LoadFormula";
export let LoadFormulaComboItems = baseUrl+"basesetting/formula/LoadFormulaComboItems";
//////////////////////////

// //Product Price Formula Url Set
// export let registerFormula = baseUrl+"basesetting/formula/AddFormula";

// export let ActiveFormula = baseUrl+"basesetting/formula/ActiveFormula";
// export let DisableFormula = baseUrl+"basesetting/formula/DisableFormula";
// export let DeleteFormula = baseUrl+"basesetting/formula/DeleteFormula";
// export let LoadFormula = baseUrl+"basesetting/formula/LoadFormula";
// export let LoadFormulaComboItems = baseUrl+"basesetting/formula/LoadFormulaComboItems";
// //////////////////////////

//Product MCountry Url Set
export let registerMCountry = baseUrl+"basesetting/mcountry/AddMCountry";
export let ActiveMCountry = baseUrl+"basesetting/mcountry/ActiveMCountry";
export let updateMCuntry = baseUrl+"basesetting/mcountry/UpdateMCountry";
export let DisableMCountry = baseUrl+"basesetting/mcountry/DisableMCountry";
export let DeleteMCountry = baseUrl+"basesetting/mcountry/DeleteMCountry";
export let LoadMCountry = baseUrl+"basesetting/mcountry/LoadMCountry";
export let LoadMCountryComboItems = baseUrl+"basesetting/mcountry/LoadMCountryComboItems";
//////////////////////////

//Product Energy Usage + Gift Wrapper Url Set
export let registerEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/AddEnergyGiftWrapp";
export let ActiveEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/ActiveEnergyGiftWrapp";
export let updateEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/UpdateEnergyGiftWrapp";
export let DisableEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/DisableEnergyGiftWrapp";
export let DeleteEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/DeleteEnergyGiftWrapp";
export let LoadEnergyGiftWrapp = baseUrl+"basesetting/EnergyGiftWrapp/LoadEnergyGiftWrapp";
export let LoadEnergyGiftWrappComboItems = baseUrl+"basesetting/EnergyGiftWrapp/LoadComboEnergyGiftWrapp";
//////////////////////////

//Pages Content Manage
export let AddPageContent = baseUrl+"dynamicpages/addpagecontent";
export let GetPageContent = baseUrl+"dynamicpages/getpagecontent";
export let GetSocialTitles = baseUrl+"dynamicpages/getsocialtitles";

export let AddDepartment = baseUrl+"dynamicpages/AddDepartment";
export let UpdateDepartment = baseUrl+"dynamicpages/UpdateDepartment";
export let ActiveDepartment = baseUrl+"dynamicpages/ActiveDepartment";
export let DeactiveDepartment = baseUrl+"dynamicpages/DeativeDepartment";
export let DeleteDepartment = baseUrl+"dynamicpages/DeleteDepartment";
export let LoadDepartments = baseUrl+"dynamicpages/LoadDepartments";

export let SetIndexBox = baseUrl+"dynamicpages/SetIndexBox";
export let LoadIndexBox = baseUrl+"dynamicpages/GetIndexBox";
//////////////////////////
//Services and profits Urls Set
export let AddService = baseUrl+"dynamicpages/AddService";
export let UpdateService = baseUrl+"dynamicpages/UpdateService";
export let ActiveService = baseUrl+"dynamicpages/ActiveService";
export let DisableService = baseUrl+"dynamicpages/DisableService";
export let DeleteService = baseUrl+"dynamicpages/DeleteService";
export let LoadServices = baseUrl+"dynamicpages/LoadServices";
//////////////////////////
//Certificate Urls Set
export let AddCertificate = baseUrl+"Certificate/Add";
export let UpdateCertificate = baseUrl+"Certificate/Edit";
export let ActiveCertificate = baseUrl+"Certificate/Active";
export let DisableCertificate = baseUrl+"Certificate/Disable";
export let DeleteCertificate = baseUrl+"Certificate/Delete";
export let LoadCertificate = baseUrl+"Certificate/Get";
//////////////////////////
//Faq categories
export let AddFaqCategory = baseUrl+"basesetting/base/AddFaqCategory";
export let UpdateFaqCategory = baseUrl+"basesetting/base/UpdateFaqCategory";
export let ActiveFaqCategory = baseUrl+"basesetting/base/ActiveFaqCategory";
export let DeleteFaqCategory = baseUrl+"basesetting/base/DeleteFaqCategory";
export let DisableFaqCategory = baseUrl+"basesetting/base/DisableFaqCategory";
export let LoadFaqCategory = baseUrl+"basesetting/base/LoadFaqCategory";
export let LoadFaqCategoryCombo = baseUrl+"basesetting/base/LoadFaqCategoryCombo";
//////////////////////////
//Faq 
export let AddFaq = baseUrl+"basesetting/base/AddFaq";
export let UpdateFaq = baseUrl+"basesetting/base/UpdateFaq";
export let ActiveFaq = baseUrl+"basesetting/base/ActiveFaq";
export let DeleteFaq = baseUrl+"basesetting/base/DeleteFaq";
export let DisableFaq = baseUrl+"basesetting/base/DisableFaq";
export let LoadFaq = baseUrl+"basesetting/base/LoadFaq";
//////////////////////////
//Header notifications
export let AddHnotify = baseUrl+"basesetting/base/AddHeaderNotify";
export let UpdateHnotify = baseUrl+"basesetting/base/UpdateHeaderNotify";
export let ActiveHnotify = baseUrl+"basesetting/base/ActiveHeaderNotify";
export let DisableHnotify = baseUrl+"basesetting/base/DisableHeaderNotify";
export let LoadHnotify = baseUrl+"basesetting/base/LoadHeaderNotifies";
//////////////////////////
//Media Gallery Category Urls Set
export let registerGalleryCat = baseUrl+"content/gallery/gallerycat/AddCategory";
export let updateGalleryCat = baseUrl+"content/gallery/gallerycat/UpdateGalleryCategory";
export let ActiveGalleryCat = baseUrl+"content/gallery/gallerycat/ActiveCategory";
export let DisableGalleryCat = baseUrl+"content/gallery/gallerycat/DisableCategory";
export let DeleteGalleryCat = baseUrl+"content/gallery/gallerycat/DeleteCategory";
export let LoadGalleryCat = baseUrl+"content/gallery/gallerycat/LoadGalleryCats";
export let LoadGalleryCatCombo = baseUrl+"content/gallery/gallerycat/LoadIGComboItems";
/////////////////////////

//Notices Category Urls Set
export let registerNoticesCat = baseUrl+"notices/noticescategory/AddCategory";
export let updateNoticesCat = baseUrl+"notices/noticescategory/UpdateNoticesGategory";
export let ActiveNoticesCat = baseUrl+"notices/noticescategory/ActiveCategory";
export let DisableNoticesCat = baseUrl+"notices/noticescategory/DisableCategory";
export let DeleteNoticesCat = baseUrl+"notices/noticescategory/DeleteCategory";
export let LoadNoticesCat = baseUrl+"notices/noticescategory/LoadNoticesCats";
export let LoadNoticesCatCombo = baseUrl+"notices/noticescategory/LoadIGComboItems";
/////////////////////////

//Notices Urls Set
export let registerNotices = baseUrl+"notices/AddNotices";
export let updateNotices = baseUrl+"notices/UpdateNotices";
export let ActiveNotices = baseUrl+"notices/ActiveNotices";
export let DisableNotices = baseUrl+"notices/DisableNotices";
export let DeleteNotices = baseUrl+"notices/DeleteNotices";
export let LoadNotices = baseUrl+"notices/LoadNotices";
/////////////////////////
//Product Urls Set
export let SetProductAttr = baseUrl+"product/SetProductAttr";
export let GetProductAttr = baseUrl+"product/GetProductAttr/";
export let DownloadExcel = baseUrl+"product/DownloadExcel/";

export let registerProduct = baseUrl+"product/AddProduct";
export let updateProduct = baseUrl+"product/UpdateProduct";
export let ActiveProduct = baseUrl+"product/ActiveProduct";
export let DisableProduct = baseUrl+"product/DisableProduct";
export let DeleteProduct = baseUrl+"product/DeleteProduct";
export let LoadProduct = baseUrl+"product/LoadProducts";
export let SearchProduct = baseUrl+"product/SearchProduct";
export let LoadProductForRelationTable = baseUrl+"product/LoadProductsDeletePid";
export let LoadProductForBoxs = baseUrl+"product/LoadProductsForBoxs";
export let LoadProductForBoxsRemDiscount = baseUrl+"product/LoadProductsForBoxsDontRemDiscount";
export let ProductAddRelation = baseUrl+"product/AddProductRelation";
export let ProductGetRelations = baseUrl+"product/GetProductRelation";
export let ProductAddPerfect = baseUrl+"product/AddProductPefrect";
export let ProductGetPerfect = baseUrl+"product/GetProductPerfect";
export let ProductAddGift = baseUrl+"product/AddProductGift";
export let ProductGetGift = baseUrl+"product/GetProductGift";
export let ProductAddSet = baseUrl+"product/AddProductSet";
export let ProductGetSet = baseUrl+"product/GetProductSet";

export let ProductExpertReviewAdd = baseUrl+"ExpertReview/AddExpertReview";
export let ProductExpertReviewUpdate = baseUrl+"ExpertReview/UpdateExpertReview";
export let ProductExpertReviewActive = baseUrl+"ExpertReview/ActiveExpertReview";
export let ProductExpertReviewDisable = baseUrl+"ExpertReview/DisableExpertReview";
export let ProductExpertReviewDelete = baseUrl+"ExpertReview/DeleteExpertReview";
export let ProductExpertReviewLoad = baseUrl+"ExpertReview/LoadExpertReviews";

export let ProductManualAdd = baseUrl+"product/AddProductManual";
export let DeleteProductManual = baseUrl+"product/DeleteProductManual";
export let ProductManualLoad = baseUrl+"product/GetProductManual";
    /**Product Combine */
export let AddProdCombine = baseUrl+"product/AddProductCombine";
export let UpdateProdCombine = baseUrl+"product/UpdateProductCombine";
export let ActiveProdCombine = baseUrl+"product/ActiveProductCombine";
export let DisablerodCombine = baseUrl+"product/DisableProductCombine";
export let DeleteProdCombine = baseUrl+"product/DeleteProductCombine";
export let LoadProdCombine = baseUrl+"product/LoadProductCombine";
/////////////////////////
//Training Urls Set
export let registerTrain = baseUrl+"training/AddTrain";
export let updateTrain = baseUrl+"training/UpdateTrain";
export let ActiveTrain = baseUrl+"training/ActiveTrain";
export let DisableTrain = baseUrl+"training/DisableTrain";
export let DeleteTrain = baseUrl+"training/DeleteTrain";
export let LoadTrain = baseUrl+"training/LoadTrainings";
/////////////////////////
//Media Gallery Child Urls Set
export let AddGalleryChild = baseUrl+"content/gallery/imagegallery/AddChild";
export let updateGalleryChild = baseUrl+"content/gallery/imagegallery/UpdateChild";
export let ActiveGalleryChild = baseUrl+"content/gallery/imagegallery/ActiveChild";
export let DisableGalleryChild = baseUrl+"content/gallery/imagegallery/DisableChild";
export let DeleteGalleryChild = baseUrl+"content/gallery/imagegallery/DeleteChild";
export let LoadGalleryChild = baseUrl+"content/gallery/imagegallery/LoadChilds";
/////////////////////////
//Catalog Urls Set
export let AddCatalog = baseUrl+"content/catalog/AddCatalog";
export let updateCatalog = baseUrl+"content/catalog/UpdateCatalog";
export let ActiveCatalog = baseUrl+"content/catalog/ActiveCatalog";
export let DisableCatalog = baseUrl+"content/catalog/DisableCatalog";
export let LoadCatalog = baseUrl+"content/catalog/LoadCatalogs";
/////////////////////////
//Media Gallery Child Urls Set
export let AddVGalleryChild = baseUrl+"content/gallery/videogallery/AddChild";
export let updateVGalleryChild = baseUrl+"content/gallery/videogallery/UpdateChild";
export let ActiveVGalleryChild = baseUrl+"content/gallery/videogallery/ActiveChild";
export let DisableVGalleryChild = baseUrl+"content/gallery/videogallery/DisableChild";
export let DeleteVGalleryChild = baseUrl+"content/gallery/videogallery/DeleteChild";
export let LoadVGalleryChild = baseUrl+"content/gallery/videogallery/LoadChilds";
/////////////////////////
//Media Slider Urls Set
export let AddSlider = baseUrl+"slider/AddSlider";
export let updateSlider = baseUrl+"slider/UpdateSlider";
export let ActiveSlider = baseUrl+"slider/ActiveSlider";
export let DisableSlider = baseUrl+"slider/DisableSlider";
export let DeleteSlider = baseUrl+"slider/DeleteSlider";
export let LoadSlider = baseUrl+"slider/LoadSliders";
/////////////////////////
//Filemanager Upload Urls
export let registerPcImg = host+"api/fm/uploadentitylogo";
export let registerSeoImg = host+"api/fm/uploadseoimage";
export let uploadVideo = host+"api/fm/uploadVideo";
export let uploadProductManual = host+"api/fm/uploadProductManual";
export let uploadDemoAudio = host+"api/fm/uploadDemoAudio";
export let uploadDPVideo = host+"api/fm/uploadDigitalPrdVideo";
export let uploadIndexSections = host+"api/fm/uploadImageFile";
export let uploadNoticesVideo = host+"api/fm/uploadNewsVideo";
export let uploadNoticesGalleryChild = host+"api/fm/uploadNoticesGalleryImage";
export let removeNoticesGalleryChild = host+"api/fm/removeNoticesGalleryImage";
export let uploadNoticesImage = host+"api/fm/uploadNoticesImage";
export let uploadSlider = host+"api/fm/uploadslider";
export let uploadNoticesAttachment = host+"api/fm/uploadArticleAttachment";
export let registerGalleryChild = host+"api/fm/uploadGalleryChild";
export let uploadFile = host+"api/fm/uploadImageFile";
//Filemanager Download Urls
export let SectionImg = host+"api/fm/dl/INDEX/SECTION/";
export let PcLogo = host+"api/fm/dl/ELOGO/PRDCATIMG/";
export let ContentLogo = host+"api/fm/dl/ELOGO/CONTENT/";
export let NoticesLogo = host+"api/fm/dl/ELOGO/NOTICESCATIMG/";
export let PLabelLogo = host+"api/fm/dl/ELOGO/PRDLABEL/";
export let WarrantyLogo = host+"api/fm/dl/ELOGO/WARRANTYIMG/";
export let BrandLogo = host+"api/fm/dl/ELOGO/PRDBRANDIMG/";
export let GalleryLogo = host+"api/fm/dl/ELOGO/GALLERYCATIMG/";
export let ImageGalleryChild = host+"api/fm/dl/GALLERYCHILD/IMAGEGALLERY/";
export let VideoGalleryChild = host+"api/fm/dl/GALLERYCHILD/VIDEOGALLERY/";
export let VideoGalleryCover = host+"api/fm/dl/GALLERYCHILD/VIDEOCOVERIMAGE/";
export let ProductGalleryImage = host+"api/fm/dl/GALLERYCHILD/PRODUCTGALLERY/";
export let NewsMedia = host+"api/fm/dl/NOTICEMEDIA/NEWSMEDIA/";
export let NewsMainImage = host+"api/fm/dl/NOTICEIMAGE/NEWSIMAGE/";
export let ArticleAttachment = host+"api/fm/dl/NOTICEIMAGE/NEWSIMAGE/";
export let ProductMainImage = host+"api/fm/dl/ELOGO/PRDIMG/";
export let ProductAudio = host+"api/fm/dl/DEMOAUDIO/NONE/";
export let ProductManualDownload = host+"api/fm/dl/PRODMANUAL/NONE/";
export let SeoUrl = host+"api/fm/dl/ESEO/";
export let SliderUrl = host+"api/fm/dl/SLIDER/NONE/";
export let CatalogFile = host+"api/fm/dl/NOTICEMEDIA/NONE/";
export let BaseDl = host+"api/fm/dl/";